<ng-template #amountLoading>
  <div class="ac-flex ac-ctr">
    <mat-spinner [diameter]="16" />
  </div>
</ng-template>
<ac-card>
  <ac-card-content>
    <div class="redemption-dialog">
      <app-redemption-dialog-header
        [step]="1"
        title="Crypto Redemption"
        subtitle="Select the crypto you'd like to receive."
        (close)="close.emit()"
        (back)="fiatRedemptionsEnabledCountry() ? back.emit() : null"
        [hideBack]="!fiatRedemptionsEnabledCountry()"
      />
      @if (dailyLimitExceeded()) {
      <div class="ac-just-ctr ac-flex">
        <div class="redemption-dialog__error-box">
          <ac-icon
            iconKey="payment:warning"
            [size]="24"
            class="redemption-dialog__error-icon"
          />
          <div class="ac-body-md">
            You've already hit your redemption limit for today.<br />
            You must wait until {{ nextAvailableDate() }} to redeem again.
          </div>
        </div>
      </div>
      }
      <div class="redemption-dialog__amount-label">
        <span class="prefix">$</span>
        <span class="amount">{{ amount() }}</span>
      </div>
      <form class="redemption-dialog__crypto-form" [formGroup]="cryptoForm">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select Crypto</mat-label>
          <mat-select
            [formControl]="cryptoForm.controls.ticker"
            class="redemption-dialog__currencies"
            required
          >
            <mat-select-trigger>
              @if (ticker()) {
              <div class="redemption-dialog__currency">
                <div class="ac-flex ac-ctr">
                  <ac-icon [iconKey]="ticker()!.ui_icon" [size]="32" />
                </div>
                <div class="redemption-dialog__currency-text">
                  <span
                    class="ac-title-md redemption-dialog__currency-symbol"
                    >{{ ticker()!.ticker }}</span
                  >
                  <span class="ac-body-sm redemption-dialog__currency-label">{{
                    ticker()!.display_name
                  }}</span>
                </div>
              </div>
              }
            </mat-select-trigger>
            @for (ticker of tickers(); track ticker.ticker) {
            <mat-option [value]="ticker.ticker">
              <div class="redemption-dialog__currency">
                <div class="ac-flex ac-ctr">
                  <ac-icon [iconKey]="ticker.ui_icon" [size]="32" />
                </div>
                <div class="redemption-dialog__currency-text">
                  <span
                    class="ac-title-md redemption-dialog__currency-symbol"
                    >{{ ticker.ticker }}</span
                  >
                  <span class="ac-body-sm redemption-dialog__currency-label">{{
                    ticker.display_name
                  }}</span>
                </div>
              </div>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (ticker() && (availableCurrencies().length > 1 ||
        ticker()!.is_multi_network)) {
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Select Network</mat-label>
          <mat-select
            [formControl]="cryptoForm.controls.currency"
            required
            class="redemption-dialog__currencies"
          >
            <mat-select-trigger>
              @if (currency()) {
              <div class="redemption-dialog__currency">
                <div class="ac-flex ac-ctr">
                  <ac-icon
                    [iconKey]="currency()!.network_ui_icon!"
                    [size]="32"
                  />
                </div>
                <div class="redemption-dialog__currency-text">
                  <span
                    class="ac-title-md redemption-dialog__currency-symbol"
                    >{{ currency()!.network_ui_name }}</span
                  >
                </div>
              </div>
              }
            </mat-select-trigger>
            @for (currency of availableCurrencies(); track currency.currency_id)
            {
            <mat-option [value]="currency.currency_id">
              <div class="redemption-dialog__currency">
                <div class="ac-flex ac-ctr">
                  <ac-icon [iconKey]="currency.network_ui_icon!" [size]="32" />
                </div>
                <div class="redemption-dialog__currency-text">
                  <span
                    class="ac-title-md redemption-dialog__currency-symbol"
                    >{{ currency.network_ui_name }}</span
                  >
                </div>
              </div>
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if (currency()) {
        <mat-form-field class="disabled-interactive" subscriptSizing="dynamic">
          <mat-label>Receiving Address</mat-label>
          <input
            [formControl]="cryptoForm.controls.address"
            required
            matInput
          />
          @if (cryptoForm.controls.address.errors?.['invalidAddress']) {
          <mat-error> Invalid Address </mat-error>
          }
        </mat-form-field>
        }
      </form>
      @if (currency()) {
      <ul class="redemption-dialog__crypto-confirm-table ac-body-md">
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            Estimated Fee
          </div>
          @if (feeEstimate(); as fee) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ fee | decimal : currency()!.ui_decimals }}
              {{ currency()!.ticker }}
            </div>
          </div>
          } @else if (feeEstimateFailed()) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>&mdash;</div>
          </div>
          } @else {
          <div class="ac-flex ac-ctr">
            <mat-spinner [diameter]="16" />
          </div>
          }
        </li>
        <li>
          <div class="redemption-dialog__crypto-confirm-table-key">
            You'll Receive
          </div>
          @if (netAmount(); as net) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>
              {{ net | decimal : currency()!.ui_decimals }}
              {{ currency()!.ticker }}
            </div>
          </div>
          } @else if (feeEstimateFailed()) {
          <div class="redemption-dialog__crypto-confirm-table-value">
            <div>&mdash;</div>
          </div>
          } @else {
          <div class="ac-flex ac-ctr">
            <mat-spinner [diameter]="16" />
          </div>
          }
        </li>
      </ul>
      @if (feeEstimateFailed()) {
      <div class="redemption-dialog__footer ac-body-sm text-warning">
        We couldn't load the fee estimate.
        <button
          type="button"
          class="redemption-dialog__link"
          (click)="retryFeeEstimate(); $event.preventDefault()"
        >
          Try again
        </button>
      </div>
      }
      <div class="ac-just-ctr ac-flex">
        <div
          [class.redemption-dialog__message-box]="!showPaypalWarning()"
          [class.redemption-dialog__warning-box]="showPaypalWarning()"
          [style.background-color]="
            !showPaypalWarning()
              ? networkIconMessageBackgroundColor()
              : undefined
          "
          [style.border]="
            !showPaypalWarning() ? networkIconMessageBorder() : undefined
          "
        >
          <ac-icon
            [iconKey]="
              !showPaypalWarning() ? currency()!.network_ui_icon! : 'hr:warning'
            "
            [size]="24"
          />
          <div class="ac-body-sm">
            @if (showPaypalWarning()) {
            <strong>Important</strong>: Only send to a USDC wallet address on
            the {{ currency()!.network_ui_name }} network. Do NOT enter a PayPal, Venmo
            or non-{{ currency()!.network_ui_name }} address — funds will be
            permanently lost. } @else {
            {{ currency()!.network_ui_name }} redemptions must be sent to a
            {{ currency()!.network_ui_name }} address. If you redeem to a non-{{
              currency()!.network_ui_name
            }}
            address your funds may be lost. }
          </div>
        </div>
      </div>
      }
      <button
        [disabled]="
          this.cryptoForm.invalid ||
          dailyLimitExceeded() ||
          hasPlaythroughRequirement() ||
          awaitingFeeEstimate()
        "
        [loading]="submitting()"
        (click)="submit(); $event.preventDefault()"
        mat-flat-button
        class="ac-btn-lg"
      >
        Redeem {{ amount() | currency : 'USD' : 'symbol-narrow' }}
      </button>
      @if (submittingTimedOut()) {
        <div class="redemption-dialog__footer ac-body-sm text-warning">
          This is taking longer than expected. Please try again.
        </div>
      }
      @if (hasPlaythroughRequirement()) {
      <div class="redemption-dialog__footer ac-body-sm text-warning">
        Due to a recent purchase, your Playthrough Requirement has changed.
        Please refresh the page.
      </div>
      }
      <div class="redemption-dialog__footer">
        {{ minimumRedemptionAmount.toFixed(2) }} SC minimum redemption.
      </div>
    </div>
  </ac-card-content>
</ac-card>
